import {actionNames} from 'constant/index';
const mapDispatchToProps = dispatch => ({
});
export default mapDispatchToProps;